import React, { createContext, useState } from 'react';
import { Constants } from '../../constants/Variables';
import { createContextHook } from '../contextUtils';

// VisualizationContext manages overall visualization settings and states
const VisualizationContext = createContext();

export function VisualizationProvider({ children }) {
  // Available sections/charts list
  const [sectionList, setSectionList] = useState(null);
  // Currently selected section/chart
  const [selectedSection, setSelectedSection] = useState(null);
  // Current visualization type (Map/Bar/Line)
  const [visualization, setVisualization] = useState(Constants.Map);
  // Current view level (State/District)
  const [view, setView] = useState(Constants.State);
  // Chart title and unit display
  const [chartHeading, setChartHeading] = useState("");
  const [chartUnit, setChartUnit] = useState("");
  // Loading state for charts
  const [chartLoading, setChartLoading] = useState(true);
  // Selected year for visualization
  const [selectedYear, setSelectedYear] = useState("");
  // Comparison mode states
  const [compareSelectedSection, setCompareSelectedSection] = useState(null);
  const [compareFlag, setCompareFlag] = useState(false);
  const [selectedCompareId, setSelectedCompareId] = useState(null);
  const [compareFilterInfo, setCompareFilterInfo] = useState("");
  const [compareSource, setCompareSource] = useState("");
  // Available geographic levels
  const [availableLevels, setAvailableLevels] = useState(null);
  // Selected year for comparison visualization
  const [compSelectedYear, setCompSelectedYear] = useState("");

  const value = {
    sectionList, setSectionList,
    selectedSection, setSelectedSection,
    visualization,setVisualization,
    view, setView,
    chartHeading, setChartHeading,
    chartUnit, setChartUnit,
    chartLoading, setChartLoading,
    selectedYear, setSelectedYear,
    compareSelectedSection, setCompareSelectedSection,
    compareFlag, setCompareFlag,
    selectedCompareId, setSelectedCompareId,
    compareFilterInfo, setCompareFilterInfo,
    compareSource, setCompareSource,
    availableLevels, setAvailableLevels,
    // compare visualization
    compSelectedYear, setCompSelectedYear
  };

  return (
    <VisualizationContext.Provider value={value}>
      {children}
    </VisualizationContext.Provider>
  );
}

export const useVisualization = createContextHook(VisualizationContext, 'useVisualization');